import { useEffect, useRef } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./core/Auth";

export function Logout() {
  const { logout } = useAuth();
  // Once: logout() changes identity on every render, so the effect would run again.
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    // Reload only after the server has ended the session. Reloading at once cancelled the
    // POST /auth/logout, so the session cookie survived and the student portal's Sign out
    // (and opening /logout) left the user signed in.
    // Typed as returning nothing in the auth context, but it returns the server call's promise.
    Promise.resolve(logout())
      .catch(() => undefined)
      .then(() => window.location.reload());
  }, [logout]);

  return (
    <Routes>
      <Route index element={<Navigate to="/auth/login" />} />
    </Routes>
  );
}
